import React from 'react';

const EscapeProtocolWiki = () => {
const navigationItems = [
  { 
    title: 'DIM. ANOMALIES', 
    color: 'text-blue-400', 
    image: 'https://cdn.4fingerstudios.com/Wiki/Navigation_Unknown.png',
    href: '/dimensional-anomalies'
  },
  { 
    title: 'DIMENSIONS', 
    color: 'text-blue-400', 
    image: 'https://cdn.4fingerstudios.com/Wiki/Navigation_Unknown.png',
    href: '/dimensions'
  },
  { 
    title: 'NECROVA CO.', 
    color: 'text-blue-400', 
    image: 'https://cdn.4fingerstudios.com/Wiki/Navigation_Unknown.png',
    href: '/necrova-co'
  },
  { 
    title: 'PROTOCOLS', 
    color: 'text-pink-400', 
    image: 'https://cdn.4fingerstudios.com/Wiki/Navigation_Unknown.png',
    href: '/protocols'
  },
  { 
    title: 'COSMETICS', 
    color: 'text-blue-400', 
    image: 'https://cdn.4fingerstudios.com/Wiki/Navigation_Unknown.png',
    href: '/cosmetics'
  },
  { 
    title: 'EQUIPMENT', 
    color: 'text-red-400', 
    image: 'https://cdn.4fingerstudios.com/Wiki/Navigation_Tiny_Unknown.png',
    href: '/equipment'
  },
  { 
    title: 'ACHIEVEMENTS', 
    color: 'text-red-400', 
    image: 'https://cdn.4fingerstudios.com/Wiki/Navigation_Tiny_Unknown.png',
    href: '/achievements'
  },
  { 
    title: 'DATA CELLS', 
    color: 'text-red-400', 
    image: 'https://cdn.4fingerstudios.com/Wiki/Navigation_Tiny_Unknown.png',
    href: '/data-cells'
  },
  { 
    title: 'DATA BANKS', 
    color: 'text-red-400', 
    image: 'https://cdn.4fingerstudios.com/Wiki/Navigation_Tiny_Unknown.png',
    href: '/data-banks'
  },
  { 
    title: 'LORE', 
    color: 'text-red-400', 
    image: 'https://cdn.4fingerstudios.com/Wiki/Navigation_Tiny_Unknown.png',
    href: '/lore'
  },
  { 
    title: 'MECHANICS', 
    color: 'text-blue-400', 
    image: 'https://cdn.4fingerstudios.com/Wiki/Navigation_Tiny_Unknown.png',
    href: '/mechanics'
  },
  { 
    title: 'DEVELOPMENT', 
    color: 'text-red-400', 
    image: 'https://cdn.4fingerstudios.com/Wiki/Navigation_Tiny_Unknown.png',
    href: '/development'
  },
  { 
    title: 'PERKS', 
    color: 'text-red-400', 
    image: 'https://cdn.4fingerstudios.com/Wiki/Dimension_Unknown.png',
    href: '/perks'
  },
  { 
    title: 'ANOMABILITIES', 
    color: 'text-blue-400', 
    image: 'https://cdn.4fingerstudios.com/Wiki/Dimension_Unknown.png',
    href: '/anomabilities'
  },
  { 
    title: 'BATTLE PASSES', 
    color: 'text-red-400', 
    image: 'https://cdn.4fingerstudios.com/Wiki/Dimension_Unknown.png',
    href: '/battle-passes'
  },
];
const NavigationCard = ({ title, color, image }) => (
  <div className="relative overflow-hidden h-32 hover:scale-105 transition-transform cursor-pointer group bg-gray-800 border border-gray-600 rounded-lg">
    <img 
      src={image} 
      alt={title}
      className="w-full h-full object-cover"
      onError={(e) => {
        e.target.style.display = 'none';
        e.target.nextSibling.style.display = 'flex';
      }}
    />
    <div className="w-full h-full hidden items-center justify-center bg-gradient-to-br from-gray-700 to-gray-800">
      <div className="text-center p-4">
        <div className="w-8 h-8 bg-gray-600 rounded-full mx-auto mb-2 flex items-center justify-center">
          <div className="w-4 h-4 bg-gray-400 rounded-sm"></div>
        </div>
        <div className={`text-xs font-bold ${color}`}>{title}</div>
      </div>
    </div>
    <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-75 p-2 opacity-0 group-hover:opacity-100 transition-opacity">
      <div className={`text-xs font-bold text-center ${color}`}>{title}</div>
    </div>
  </div>
);
  return (
    <div className="min-h-screen bg-black text-white">
      {/* Header */}
     <div className="flex justify-center pt-8 pb-4">
  <img 
    src="https://cdn.4fingerstudios.com/Wiki/Escape_Protocol_Wiki_Banner.png" 
    alt="Escape Protocol Wiki Banner"
    className="max-w-2xl rounded-2xl border-4 border-gray-300"
  />
</div>

      {/* Main Content */}
      <div className="max-w-6xl mx-auto px-4">
        {/* Welcome Section */}
        <div className="text-center mb-8">
          <h1 className="text-3xl text-blue-400 mb-4">Welcome to the official Escape Protocol Wiki!</h1>
          <div className="text-gray-300">
            <span className="text-white">25</span> articles • <span className="text-white">154</span> total edits • <span className="text-white">6</span> files uploaded
          </div>
        </div>

        {/* Description */}
        <div className="bg-gray-900 p-6 rounded-lg mb-8 border border-gray-700">
          <p className="text-gray-300 mb-4">
            In Escape Protocol, you play as a lower-class employee of <span className="text-blue-400">Necrova Corporation</span> assigned in the role of a <span className="text-blue-400">Data Collector Agent</span>. You, along with five other Agents are tasked to enter the <span className="text-blue-400">Dimensional Teleporter</span> in order to collect as much precious data as possible gathered by the Data Generators located in the other Dimensions that you and your team have been sent to. However, due to poor decisions from the higher-ups of Necrova, the Dimensional Teleporter is extremely unstable and will always turn one of the members of the teleported Agents into a <span className="text-blue-400">Dimensional Anomaly</span>. Their goal is as simple as it gets: Find and kill everyone on sight.
          </p>
          <p className="text-gray-300 mb-4">
            Escape Protocol is an asymmetrical 5v1 multiplayer horror game developed by <span className="text-blue-400">4 Finger Studios</span>. Escape Protocol is inspired by Behaviour's "Dead by Daylight", Zeekerss' "Lethal Company" and Ghost Ship Games' "Deep Rock Galactic".
          </p>
          <div className="text-right">
            <button className="text-blue-400 hover:text-blue-300 font-bold">READ MORE</button>
          </div>
        </div>

        {/* Navigation */}
        <div className="mb-8">
          <h2 className="text-2xl font-bold text-center mb-6">NAVIGATION</h2>
          <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-4">
            {navigationItems.slice(0, 6).map((item, index) => (
              <NavigationCard key={index} title={item.title} color={item.color} />
            ))}
          </div>
          <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-7 gap-4 mt-4">
            {navigationItems.slice(6, 13).map((item, index) => (
              <NavigationCard key={index + 6} title={item.title} color={item.color} />
            ))}
          </div>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-4 max-w-2xl mx-auto">
            {navigationItems.slice(13).map((item, index) => (
              <NavigationCard key={index + 13} title={item.title} color={item.color} />
            ))}
          </div>
        </div>

      </div>

      {/* Footer */}
      <footer className="bg-gray-900 border-t border-gray-700 py-8 mt-12">
        <div className="max-w-6xl mx-auto px-4 text-center text-gray-400">
          <p>&copy; 2025 4FingerStudios.</p>
        </div>
      </footer>
    </div>
  );
};

export default EscapeProtocolWiki;